import styled from 'styled-components';
import { FaAngleRight } from "react-icons/fa";
import { ImWhatsapp } from "react-icons/im";
import { Link } from 'react-router-dom';
import logo from "../assets/logos/logo.jpg";

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 50px;
    /* display: flex;
    align-items: center;
    justify-content: center; */
`;

const Logo = styled.img`
    border-radius: 50%;
    object-fit: cover;
    height: 60px;
    width: 60px;
    box-shadow: 2px 2px 4px #333;

    @media (min-width: 780px) {
        height: 60px;
        width: 60px;
    }
`

const Line = styled.div`
    background-image: linear-gradient( #f2c70f, #494544);
    height: 70px;
    width: 3px;
    border-radius: 50px;
    margin: 0 15px;

    @media (min-width: 780px) {
        height: 80px;
    }
`;

const Name = styled.h2`
    color: #fff;
    text-transform: uppercase;
    line-height: 2.3rem;
    /* font-size: 2.2rem; */
    font-size: 1.8rem;
    font-weight: 700;
    font-style: italic;
    text-shadow: 1px 1px 0px #f2c70f;

    @media (min-width: 780px) {
        font-size: 1.8rem;
    }
`


const Footer = () => {
    const year = new Date().getFullYear();

  return (
    <Container>
        
        <FotterContainer>

            <Wrapper>
                <Logo src={logo} /> 
                <Line></Line>
                <Name> 
                    <span style={{color: "#f2c70f", textShadow: "1px 1px #494544"}}>Remold</span> <br /> Serviços
                </Name>
            </Wrapper>

            <List>
                <ListTitle>menu rápido</ListTitle>
                <ListItem> 
                    <Icon><FaAngleRight /></Icon>  <Link style={{color: "inherit", textDecoration: "none"}} to={"/"}>Home</Link>
                </ListItem>
                <ListItem> 
                    <Icon> <FaAngleRight /></Icon> <Link style={{color: "inherit", textDecoration: "none"}} to={"/empresa"}>Empresa</Link>
                </ListItem>
                <ListItem> 
                    <Icon> <FaAngleRight/></Icon>  <Link style={{color: "inherit", textDecoration: "none"}} to={"/serviços"}>Serviços</Link>
                </ListItem>
                <ListItem> 
                    <Icon> <FaAngleRight /></Icon>  <Link style={{color: "inherit", textDecoration: "none"}} to={"/contato"}>Contato</Link>
                </ListItem>
               
            </List>

            <List>
                <ListTitle>Nossos Serviços</ListTitle>
                <ListItem> 
                    <Icon><FaAngleRight /></Icon>  <Link style={{color: "inherit", textDecoration: "none"}} to={"/serviços"}>Manutenção Predial </Link>
                </ListItem>
                <ListItem> 
                    <Icon> <FaAngleRight /></Icon> <Link style={{color: "inherit", textDecoration: "none"}} to={"/serviços"}>Manutenção Residencial </Link>
                </ListItem>
                <ListItem> 
                    <Icon> <FaAngleRight /></Icon>  <Link style={{color: "inherit", textDecoration: "none"}} to={"/serviços"}>Manutenção de Condomínio</Link>
                </ListItem>
           
            </List>
            
            <List style={{marginBottom: "0"}}>
                <ListTitle>Entre em Contato</ListTitle>
                <ListItem> 
                   <p style={{color: "#ffffffb0", lineHeight: "1.5rem"}}>
                       REMOLD SERVIÇOS – Rua Teste, 999
                       - Centro de Santos – SP – Brazil – cep: 11111-111
                    </p> 
                </ListItem>
                <ListTitle2 style={{margin: "15px 0 5px 0"}}><InfoIcon> <ImWhatsapp /> </InfoIcon>(13) 99161-8326</ListTitle2>
                {/* <ListItem> 
                   <p style={{color: "#ffffffb0"}}>
                        info@remold.com
                    </p> 
                </ListItem> */}
            </List>

            
        </FotterContainer>
        <FooterBottom>
            &copy; {year} - <span style={{color: "#f2c70f"}}> <i>REMOLD SERVIÇOS</i> - Empresa de Reformas, Manutenção e Reparos em Santos e SP</span>
        </FooterBottom>
    </Container>
  )
}

const Container = styled.footer`
    margin-top: 50px;
    overflow: hidden;
`;

const FotterContainer = styled.div`
    border-top: 10px solid #f2c80f;
    border-bottom: 1px solid #ffffff2b;
    padding: 40px 20px;
    background-color: #494544;
    display: grid;
    grid-template-columns: 1fr;

    @media (min-width: 650px) {
        grid-template-columns: 1.4fr 0.8fr 1.2fr 1fr;
        padding: 60px 50px;
    }
`;

const List = styled.ul`
    color: #ffffffb0;
    margin-bottom: 50px;


    @media (min-width: 650px) {
        margin: 0;

    }
`;

const ListTitle = styled.p`
    color: #ffffffdc;
    font-weight: 400;
    font-size: 1.1rem;
    text-transform: uppercase;
    margin-bottom: 25px;
 
`;

const ListTitle2 = styled.div`
    color: #f2c70f;
    font-weight: bold;
    font-size: 1.1rem;
    text-transform: uppercase;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
`

const ListItem = styled.li`
    list-style: none;
    margin-bottom: 5px;
    font-size: 0.9rem;
    &:hover {
        color: #fff;
    }
`;


const Icon = styled.span`
    font-size: 0.7rem;
    margin-right: 8px;
    color: #f2c70f;
`;

const InfoIcon = styled.div`
    color: #f2c70f;
    font-size: 1.1rem;
    margin-right: 8px;
    margin-bottom: -8px;
`

const FooterBottom = styled.div`
    background-color: #333;
    padding: 20px 50px;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 300;
    color: #fff;
    
`;

export default Footer